import "../../../../styles/productViewListItem.scss";

import Icon, {iconColor, iconTypes} from "../../../common/components/Icon.jsx";
import {canWorkWithOrder, countAddedProduct, countWhat, getProductOrderProperty} from "../../util/orderUtil.js";

import {Localization} from "../../../common/util/localization.jsx";
import ProductViewModal from "./ProductViewModal";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../../common/components/ResponsiveColumn";
import ResponsiveRows from "../../../common/components/ResponsiveRows";

// Component that contains the column headers of a list
// Certain columns are sortable and are displayd as buttons with an up or down arrow icon to indicate the sorting order.
export class ProductViewListHeader extends React.PureComponent {

    constructor(props){
        super(props);
        this.sortProductName = this.sortProductName.bind(this);
        this.sortEpdNo = this.sortEpdNo.bind(this);

        this.state = { sortDescendingName: false, sortAscendingName: false, sortDescendingEpdNo: false, sortAscendingEpdNo: false, };
    }

    sortProductName()
    {       
        // reverse the sort order
        const ascending =  this.state.sortDescendingName || !this.state.sortAscendingName;
        const descending =  !ascending;
       
        this.setState( { sortDescendingName: descending, sortAscendingName : ascending, sortDescendingEpdNo: false, sortAscendingEpdNo: false });

        // Kolla denna för fakturareklamation: använder state.history.invoices[parseInt(ownProps.match.params.invoiceId || "0")].invoiceLines 
        // Borde inte anropa loadMoreProducts som är undefined

        this.props.editQueryFilter({
            SortingColumn: "ProductName",
            SortDescending: descending,
        });
        
        this.props.loadMoreProducts(50);
    }

    sortEpdNo()
    {       
        // reverse the sort order
        const ascending =  this.state.sortDescendingEpdNo || !this.state.sortAscendingEpdNo;
        const descending =  !ascending;
       
        this.setState( { sortDescendingEpdNo: descending, sortAscendingEpdNo : ascending, sortDescendingName: false, sortAscendingName: false });

        this.props.editQueryFilter({
            SortingColumn: "EpdNo",
            SortDescending: descending,
        });

        this.props.loadMoreProducts(50);
    }

    render(){
        const {
            deviceType,
            localization,
        } = this.props;

        switch(deviceType) {
        case "xs":
            return (
                <div style={{marginTop:"8px", marginBottom:"8px"}}>
                    <ResponsiveRows gutters={false}>
                        <ResponsiveColumn xs={8}>
                            <div className="product-view-list-header" style={{textIndent:"70px"}}>
                                {localization.text("order","view","product")}
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={4}>
                            <div className="product-view-list-header" style={{width:"100%",textAlign:"right"}}>
                                {localization.text("order","view","inTheOrder")}
                            </div>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                </div>
            );
        case "sm":
            return (
                <div style={{marginTop:"8px", marginBottom:"8px"}}>
                    <ResponsiveRows gutters={false}>
                        <ResponsiveColumn xs={6}>
                            <div className="product-view-list-header" style={{textIndent:"70px"}}>
                                {localization.text("order","view","product")}
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={3}>
                            <div className="product-view-list-header" style={{width:"100%"}}>
                                {localization.text("order","view","pricePerPac")}
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={3}>
                            <div className="product-view-list-header" style={{width:"100%",textAlign:"right"}}>
                                {localization.text("order","view","inTheOrder")}
                            </div>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                </div>
            );
        default:
            return (
                <div style={{marginTop:"6px", marginBottom:"7px"}}>
                    <ResponsiveRows gutters={false}>
                        <ResponsiveColumn xs={5} lg={6}>
                            <div className="product-view-list-header" style={{textIndent:"70px"}}>                              
                                <button  className="btn-sort" onClick={this.sortProductName}>
                                    {!this.state.sortAscendingName && !this.state.sortDescendingName &&  (<Icon type={iconTypes.arrowUpDown} />)}
                                    {this.state.sortAscendingName && (<Icon type={iconTypes.arrowUp} />)}
                                    {this.state.sortDescendingName && (<Icon type={iconTypes.arrowDown} />)}
                                    {localization.text("order","view","product")}
                                </button>                               
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={0} lg={1}>
                            <div className="product-view-list-header" style={{width:"100%"}}>
                                <button  className="btn-sort" onClick={this.sortEpdNo}>
                                    {!this.state.sortAscendingEpdNo && !this.state.sortDescendingEpdNo &&  (<Icon type={iconTypes.arrowUpDown} />)}
                                    {this.state.sortAscendingEpdNo && (<Icon type={iconTypes.arrowUp} />)}
                                    {this.state.sortDescendingEpdNo && (<Icon type={iconTypes.arrowDown} />)}
                                    {localization.text("order", "epd")}
                                </button>       
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={1} lg={1}>
                            <div className="product-view-list-header" style={{width:"100%"}}>
                                {localization.text("order","view","price")}
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={2} lg={1}>
                            <div className="product-view-list-header" style={{width:"100%"}}>
                                {localization.text("order","view","perPack")}
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={1} lg={1}>
                            <div className="product-view-list-header" style={{width:"100%"}}>
                                {localization.text("order","view","category")}
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={3} lg={2}>
                            <div className="product-view-list-header" style={{width:"100%",textAlign:"right"}}>
                                {localization.text("order","view","inTheOrder")}
                            </div>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                </div>
            );
        }
    }
}

ProductViewListHeader.propTypes = {
    deviceType: PropTypes.string.isRequired,
    localization: Localization.propTypes.isRequired,
    loadMoreProducts: PropTypes.func,
    editQueryFilter: PropTypes.func,
};

// Component that displays a product as a single row in a list.
// Consists of columns for image, product name, epd no, price and product type.
// This is used when searching for products and the shopping cart.
export class ProductViewListItem extends React.PureComponent {
    constructor(props){
        super(props);

        this.state = {
            counter: 0,
        };

        this.change = this.change.bind(this);
        this.showProductModal = this.showProductModal.bind(this);
        this.closeProductModal = this.closeProductModal.bind(this);
        this.onSwapReplacedProduct = this.onSwapReplacedProduct.bind(this);
    }
    change(change) {
        const {
            addRemoveProductToTemporaryOrder,
            product,
        } = this.props;

        addRemoveProductToTemporaryOrder(product, change.value, change.salesLineId);
    }
    showProductModal(event) {
        event.stopPropagation();
        event.preventDefault();

        const {
            localization,
            product,
            list,
            salesLineId,
        } = this.props;

        this.props.setModal(<ProductViewModal localization={localization} product={product} activeOrder={list} onAddProductChange={this.change} onCloseModal={this.closeProductModal} width={460} salesLineId={salesLineId}/>);
    }
    closeProductModal(event) {
        event.stopPropagation();
        event.preventDefault();
        
        this.props.setModal(null);
    }

    onSwapReplacedProduct()
    {
        const {
            product,
            swapReplacedProduct,
        } = this.props;

        swapReplacedProduct(product.productId, product.replacedByProductId);
    } 
    
    render(){
        const {
            deviceType,
            disabled,
            localization,
            product,
            counting,
            list,
            border,
            countingNode,
            style,
            draggableIcon,
            priceInSalesUnits,
            swapReplacedProduct,
            salesLineId,
        } = this.props;

        let iconType = iconTypes.x;
        if( product.productStorageType=="Tørr" ) {
            iconType = iconTypes.box;
        } else if( product.productStorageType=="Frys" ) {
            iconType = iconTypes.snowflake;
        } else if( product.productStorageType=="Kjøl" ) {
            iconType = iconTypes.thermostat;
        } 

        const addedCount = countAddedProduct(list, product.productId, counting);
        const isLocked = getProductOrderProperty(list, product.productId, "isLocked", salesLineId) || getProductOrderProperty(list, product.productId, "isKitMember", salesLineId);
        const hasWarning = getProductOrderProperty(list, product.productId, "warningText", salesLineId)!=null;
        const hasError = getProductOrderProperty(list, product.productId, "errorText", salesLineId)!=null;
        const canEdit = canWorkWithOrder(list) && !disabled && counting!=countWhat.ordered && !isLocked && !product.notActive;
        const minValue = getProductOrderProperty(list, product.productId, "mustOrderAtLeastOne", salesLineId)?1:0;
        const isOpenDistribution = getProductOrderProperty(list, product.productId, "isOpenDistributionLine", salesLineId);
        const price = hasError? "" : priceInSalesUnits ? (product.pricePerSalesUnit*addedCount).toFixed(2) : product.price.toFixed(2);
        const discountValue = (product.campaignDiscount ? `-${product.campaignDiscount.toFixed(2)}%` : "");
        
        const countingNodeWithProps = React.cloneElement(countingNode, {onEdit:this.change, value:addedCount, salesLineId:salesLineId, border:border, disabled:!canEdit, minValue:minValue, product, activeOrder:list, notActive: product.notActive});

        switch(deviceType) {
        case "xs":
            return (
                <div className="product-view-list-item-wrapper" style={style} draggable={false}>
                    <div className="container">
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={8}>
                                <div className="product-view-list-item-tiny">
                                    <div className={"product-view-list-item-image-background"}  onClick={this.showProductModal}>
                                        {product.imageUrl && (
                                            <React.Fragment>
                                                <img src={product.imageUrl} className={"product-view-list-item-image"} />
                                                <div className="warning-wrapper">
                                                    {isLocked && (
                                                        <div className="warning-bg">
                                                            <Icon type={iconTypes.lockLocked} className="lock"/>
                                                        </div>
                                                    )}
                                                    {isOpenDistribution && (
                                                        <div className="warning-bg">
                                                            <Icon type={iconTypes.lockUnlocked} className="lock"/>
                                                        </div>
                                                    )}
                                                    {minValue===1 && (
                                                        <div className="warning-bg">
                                                            <Icon type={iconTypes.lockOneLocked} className="lock"/>
                                                        </div>
                                                    )}
                                                    {hasWarning && (
                                                        <div className="warning-bg">
                                                            <Icon type={iconTypes.warningTiny} className="lock"/>
                                                        </div>
                                                    )}
                                                    {hasError && (
                                                        <div className="warning-bg">
                                                            <Icon type={iconTypes.errorTiny} className="lock"/>
                                                        </div>
                                                    )}
                                                </div>
                                            </React.Fragment>
                                        )}
                                    </div>
                                    <div style={{flexGrow:"1"}}>
                                        <div className="label14 prd-name"  onClick={this.showProductModal}>
                                            {product.productName}
                                        </div>
                                        <div className="prd-info">
                                            <div className="label10 prd-size">
                                                { priceInSalesUnits ? "" : localization.text("order","packSize",{noOfSalesUnits:product.noOfSalesUnits})}
                                            </div>
                                            <div className="label10 prd-campaign-prize-small" >
                                                { discountValue }
                                            </div>
                                            <div className={`label16 prd-price ${product.campaignDiscount ? "prd-price-campaign" : ""}`}>
                                                { price }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={4}>
                                <div className="product-view-list-item-counter-field">
                                    { swapReplacedProduct && product.replacedByProductId ? (
                                        <button className={"btn circular noselect draggable"} onClick={this.onSwapReplacedProduct}>
                                            <Icon type={iconTypes.recycle}/>
                                        </button>
                                    ) :  draggableIcon===true && (
                                        <Icon type={iconTypes.draggable} className="draggable" draggable="true"/>
                                    )}
                                    {countingNodeWithProps}
                                </div>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </div>
                </div>
            );
        case "sm":
            return (
                <div className="product-view-list-item-wrapper not-interactive" draggable={false} style={style}>
                    <div className="container">
                        {this.state.showModal && (
                            <ProductViewModal localization={localization} product={product} activeOrder={list} onAddProductChange={this.change} onCloseModal={this.closeProductModal} width={460}/>
                        )}
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={6}>
                                <div className="product-view-list-item-tiny">
                                    <div className={"product-view-list-item-image-background"} onClick={this.showProductModal}>
                                        {product.imageUrl && (
                                            <React.Fragment>
                                                <img src={product.imageUrl} className={"product-view-list-item-image"} />
                                                <div className="warning-wrapper">
                                                    {isLocked && (
                                                        <div className="warning-bg">
                                                            <Icon type={iconTypes.lockLocked} className="lock"/>
                                                        </div>
                                                    )}
                                                    {isOpenDistribution && (
                                                        <div className="warning-bg">
                                                            <Icon type={iconTypes.lockUnlocked} className="lock"/>
                                                        </div>
                                                    )}
                                                    {minValue===1 && (
                                                        <div className="warning-bg">
                                                            <Icon type={iconTypes.lockOneLocked} className="lock"/>
                                                        </div>
                                                    )}
                                                    {hasWarning && (
                                                        <div className="warning-bg">
                                                            <Icon type={iconTypes.warningTiny} className="lock"/>
                                                        </div>
                                                    )}
                                                    {hasError && (
                                                        <div className="warning-bg">
                                                            <Icon type={iconTypes.errorTiny} className="lock"/>
                                                        </div>
                                                    )}
                                                </div>
                                            </React.Fragment>
                                        )}
                                    </div>
                                    <div style={{flexGrow:"1"}}>
                                        <div className="label14 prd-name" onClick={this.showProductModal}>
                                            {product.productName}
                                        </div>
                                        <div className="prd-info">
                                            <div className="label10 prd-size">
                                                { priceInSalesUnits ? "" : localization.text("order","packSize",{noOfSalesUnits:product.noOfSalesUnits})}
                                            </div>
                                            <div className="label10 prd-campaign-prize-small" >
                                                { discountValue }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={3}>
                                <div className="product-view-list-item-tiny">
                                    <div className={`label16 prd-price ${product.campaignDiscount ? "prd-price-campaign" : product.notActiveText ? "prd-replaced" : ""} prd-cart-sm`}>
                                        { product.notActiveText ? 
                                            <div style={{display:"flex", textAlign: "left"}}>
                                                <Icon type={iconTypes.warning} color={iconColor.red} /> 
                                                { product.notActiveText }
                                            </div> : price }
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={3}>
                                <div className="product-view-list-item-counter-field">
                                    { product.replacedByProductId ? (
                                        <button className={"btn circular noselect draggable"} onClick={this.onSwapReplacedProduct}>
                                            <Icon type={iconTypes.recycle}/>
                                        </button>
                                    ) :  draggableIcon===true && (
                                        <Icon type={iconTypes.draggable} className="draggable" draggable="true"/>
                                    )}
                                    {countingNodeWithProps}
                                </div>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </div>
                </div>
            );
        default: 
            return (
                <div className="product-view-list-item-wrapper not-interactive" draggable={false} style={style}>
                    <div className="container">
                        {this.state.showModal && (
                            <ProductViewModal localization={localization} product={product} activeOrder={list} onAddProductChange={this.change} onCloseModal={this.closeProductModal} width={460}/>
                        )}
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={5} lg={6}>
                                <div className={"product-view-list-item-nowrap"}>
                                    <div className={"product-view-list-item-image-background"} onClick={this.showProductModal}>
                                        {product.imageUrl && (
                                            <React.Fragment>
                                                <img src={product.imageUrl} className={"product-view-list-item-image"} />
                                                <div className="warning-wrapper">
                                                    {isLocked && (
                                                        <div className="warning-bg">
                                                            <Icon type={iconTypes.lockLocked} className="lock"/>
                                                        </div>
                                                    )}
                                                    {isOpenDistribution && (
                                                        <div className="warning-bg">
                                                            <Icon type={iconTypes.lockUnlocked} className="lock"/>
                                                        </div>
                                                    )}
                                                    {minValue===1 && (
                                                        <div className="warning-bg">
                                                            <Icon type={iconTypes.lockOneLocked} className="lock"/>
                                                        </div>
                                                    )}
                                                    {hasWarning && (
                                                        <div className="warning-bg">
                                                            <Icon type={iconTypes.warningTiny} className="lock"/>
                                                        </div>
                                                    )}
                                                    {hasError && (
                                                        <div className="warning-bg">
                                                            <Icon type={iconTypes.errorTiny} className="lock"/>
                                                        </div>
                                                    )}
                                                </div>
                                            </React.Fragment>
                                        )}
                                    </div>
                                    <div className="label16 product-view-list-item-prd-name" onClick={this.showProductModal}>
                                        {product.productName}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={0} lg={1}>
                                <div className="label14 product-view-list-item-price">
                                    <div style={{width:"100%"}}>
                                        {product.epdNo}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={1} lg={1}>
                                <div className="label14 product-view-list-item-price">
                                    <div style={{width:"100%"}}>
                                        {discountValue}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={2} lg={1}>
                                <div className="label14 product-view-list-item-pack-size">
                                    <div style={{width:"100%"}}>
                                        {priceInSalesUnits ? "" : localization.text("order","packSize",{noOfSalesUnits:product.noOfSalesUnits})}
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={1} lg={1}>
                                <div className="label14 product-view-list-item-type">
                                    <div style={{width:"100%"}}>
                                        <div className="tooltip">
                                            <Icon type={iconType} />
                                            <span className="tooltiptext">{product.productStorageType}</span>
                                        </div>
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={3} lg={2}>
                                <div className="product-view-list-item-counter-field">
                                    {draggableIcon===true && (
                                        <Icon type={iconTypes.draggable} className="draggable" draggable="true"/>
                                    )}
                                    {countingNodeWithProps}
                                </div>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </div>
                </div>
            );
        }
    }
}

ProductViewListItem.propTypes = {
    addRemoveProductToTemporaryOrder: PropTypes.func,
    list: PropTypes.object.isRequired,
    deviceType: PropTypes.string.isRequired,
    localization: Localization.propTypes.isRequired,
    setModal: PropTypes.func.isRequired,
    countingNode: PropTypes.node.isRequired,
    product: PropTypes.object,
    border: PropTypes.bool,
    priceInSalesUnits: PropTypes.bool,
    draggableIcon: PropTypes.bool,
    style: PropTypes.object,
    //if we should count ordered lines
    counting: PropTypes.string,
    //If we should not use a counter
    disabled: PropTypes.bool,
    swapReplacedProduct: PropTypes.func,
    salesLineId: PropTypes.number,
};

ProductViewListItem.defaultProps = {
    counting: countWhat.everything,
    disabled: false,
};